import { Modal } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import Search from './Search'

export default function SearchModal({ opened, onClose, ...rest }) {
    const isMobile = useMediaQuery('(max-width: 50em)')

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Search Music Library"
            size="xl"
            fullScreen={isMobile}
            {...rest}
            styles={{
                title: {
                    fontSize: '1.125rem',
                    fontWeight: 700,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                },
                body: {
                    padding: 0,
                    height: isMobile ? '100%' : '70vh',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <Search />
        </Modal>
    )
}

